// extracted by mini-css-extract-plugin
export default {"component__list":"app-header-component_component__list_ajFEz"};